import { useUA } from 'context'
import { TentativeScoringQuestionItemDesktop_ExamGradingQuestionFragment } from 'generated/graphql'

export type TQuestion = {
  id: string
  seq: number
  predictionAnswer: number | null
}

const MOBILE_QUICK_QUESTION_SLICE_SIZE = 5
const DESKTOP_QUICK_QUESTION_SLICE_SIZE = 10

const createQuestionGroups = (
  questions?: Array<TentativeScoringQuestionItemDesktop_ExamGradingQuestionFragment>,
): TQuestion[][] => {
  const { isMobile } = useUA()
  const formattedQuestions: TQuestion[] =
    questions?.map((question) => ({
      id: question.id,
      seq: question.seq,
      predictionAnswer:
        question.answers && question.answers.length > 0
          ? question.answers[0]
          : null,
    })) ?? []

  const groups: TQuestion[][] = []

  const sliceSize = isMobile
    ? MOBILE_QUICK_QUESTION_SLICE_SIZE
    : DESKTOP_QUICK_QUESTION_SLICE_SIZE

  for (let i = 0; i < formattedQuestions.length; i += sliceSize) {
    groups.push(formattedQuestions.slice(i, i + sliceSize))
  }

  return groups
}

export default createQuestionGroups
